<template>
  <div class="rbu-card mt-4">
    <div class="rbu-card-header">
      <h3 class="px-4 mr-4 d-flex align-center">Section Fluctuation Summary</h3>
    </div>
    <div class="rbu-card-content">
      <v-simple-table>
        <template v-slot:default>
          <RbuSectionFluctuationTableHeader></RbuSectionFluctuationTableHeader>
          <tbody>
            <tr
              v-for="(module, moduleIdx) in fluctuationModules_not_ignored"
              :key="moduleIdx"
            >
              <td>
                <div v-if="moduleIdx === 0">Base Value</div>
              </td>
              <td>{{ module.name }}</td>
              <td>{{ module.sub_total }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- <tr>
              <td></td>
              <td>Contract Percentage</td>
              <td></td>
              <td>
                {{ parseFloat(section.contract_year.contract_percentage) }} %
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr> -->

            <ContractRbuAdjustment
              :value="section"
              @update="onUpdate"
              :override_digit="true"
              :override_digit_number="15"
            ></ContractRbuAdjustment>

            <tr>
              <td></td>
              <td class="text-right">Adjusted trade %</td>
              <td>
                <span class="font-weight-bold">
                  {{ adjustedTradePercentage }} %</span
                >
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import RbuSectionFluctuationTableHeader from "@/components/rbu/RbuSectionFluctuationTableHeader.vue";
import ContractRbuAdjustment from "@/components/contract/ContractRbuAdjustment.vue";
import { computed, watch } from "@vue/composition-api";
import floatingPointFix from "js-floating-point";

export default {
  name: "ContractSectionFluctuationContractPercentage",
  components: {
    ContractRbuAdjustment,
    RbuSectionFluctuationTableHeader,
  },
  props: {
    section: Object,
    fluctuationModules: Array,
  },
  setup(props, { root, emit }) {
    const fluctuationModules_not_ignored = computed(() => {
      return props.fluctuationModules.filter((f) => !f.ignored);
    });
    const onUpdate = function (evt) {
      console.debug("Contract Percentage Update: ", evt);

      let updates = {
        ...evt,
      };

      emit("update", updates);
    };

    const adjustedTradePercentage = computed(() => {
      let sub_total = 0;

      props.fluctuationModules.forEach((m) => {
        if (!m.ignored) {
          sub_total = floatingPointFix(Number(m.sub_total) + sub_total);
        }
      });

      let adj_value = 0;
      let adj_percentage = 100;
      try {
        adj_value = Number(props.section.adjustment_value);
      } catch (e) {
        console.debug(e);
      }

      try {
        adj_percentage = Number(props.section.adjustment_percentage);
      } catch (e) {
        console.debug(e);
      }

      if (props.section.adjustment_value_first) {
        sub_total = floatingPointFix(
          (sub_total + adj_value) * (adj_percentage / 100)
        );
      } else {
        sub_total = floatingPointFix(
          sub_total * (adj_percentage / 100) + adj_value
        );
      }

      sub_total = floatingPointFix(
        Math.round(floatingPointFix(sub_total * 100)) / 100
      );
      return sub_total;
    });

    watch(
      () => adjustedTradePercentage.value,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          emit("update", { fluctuation_value: newValue });
        }
      },
      { immediate: true }
    );

    return {
      onUpdate,
      adjustedTradePercentage,
      fluctuationModules_not_ignored,
    };
  },
};
</script>
